var fontsV2 = {
  title: {
    desktop: {
      lg: {
        fontSize: 80,
        lineHeight: 94
      },
      md: {
        fontSize: 52,
        lineHeight: 64
      },
      sm: {
        fontSize: 32,
        lineHeight: 40
      },
      xs: {
        fontSize: 24,
        lineHeight: 32
      }
    },
    mobile: {
      lg: {
        fontSize: 56,
        lineHeight: 66
      },
      md: {
        fontSize: 36,
        lineHeight: 44
      },
      sm: {
        fontSize: 26,
        lineHeight: 32
      },
      xs: {
        fontSize: 22,
        lineHeight: 28
      }
    }
  },
  body: {
    desktop: {
      lg: {
        fontSize: 18,
        lineHeight: 26
      },
      md: {
        fontSize: 16,
        lineHeight: 24
      },
      sm: {
        fontSize: 14,
        lineHeight: 20
      },
      xs: {
        fontSize: 12,
        lineHeight: 16
      }
    },
    mobile: {
      lg: {
        fontSize: 18,
        lineHeight: 26
      },
      md: {
        fontSize: 16,
        lineHeight: 24
      },
      sm: {
        fontSize: 14,
        lineHeight: 20
      },
      xs: {
        fontSize: 12,
        lineHeight: 16
      }
    }
  },
  fontWeight: {
    regular: 400,
    semibold: 600,
    bold: 700
  }
};
export default fontsV2;